import { useEffect, useState } from 'react';
import { CircularProgress, Snackbar } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

export const OfflineNotification = () => {
  const [isOnline, setIsOnline] = useState(true);
  const { t } = useI18n();

  useEffect(() => {
    const handleOffline = () => setIsOnline(false);
    const handleOnline = () => setIsOnline(true);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    if (!window.navigator.onLine) handleOffline();

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return (
    <Snackbar
      open={!isOnline}
      message={t('shared:offline')}
      action={<CircularProgress size={20} color="inherit" />}
    />
  );
};
